<template>
    <form ref="form"
        :class="[
            'pp-form',
            `is-${labelAlign}`,
        ]"
        @submit.prevent="handleSubmit">
        <slot></slot>
    </form>
</template>

<script>
import Validate from '../../../src/util/validate.js'


/**
 * 表单
 * @param {Object} model 表单域
 * @param {String} size 尺寸
 * @param {Object} fields 校验项
 * @param {String} labelWidth 表单项名称宽度
 * @param {String} labelAlign 表单项名称对齐方式['left', 'right', 'center']
 * @param {Boolean} disabled 表单禁用
 * 
 * @method validate 校验function(state : true成功|false失败)
 * @method clearValidate 清空校验
 * @method resetField 清空表单（需要model.sync)
 */
export default {
    name: 'pp-form',
    inheritAttrs: false,
    provide: function() {
        return {
            'Form': this,
        };
    },
    props: {
        model: {
            type: Object,
            default: {},
        },
        size: {
            type: String,
            default: 'normal',
            validator: function(value) {
                return ['normal', 'small', 'mini'].includes(value);
            },
        },
        labelWidth: String,
        labelAlign: {
            type: String,
            default: 'left',
            validator: function(value) {
                return ['left', 'right', 'center'].includes(value);
            },
        },
        fields: Object,
        disabled: Boolean,
    },
    data: function() {
        return {
            defaultModel: {},
            errorMsg: {},
            currentFields: Object.assign({}, this.fields),
        };
    },
    created: function() {
        this.defaultModel = Object.assign({}, this.model);
    },
    methods: {
        validate: function() {
            return new Promise((resolve, reject)=> {
                if(!Object.keys(this.currentFields).length) {
                    resolve(true)
                }

                try {
                    let results = Validate(this.model, this.currentFields);

                    this.errorMsg = results.results;
                    results.state ? resolve(true) : reject(this.errorMsg)
                }
                catch(err) {
                    console.error('validate Error:', err)
                }
            })
        },

        clearValidate: function() {
            this.errorMsg = {}
        },

        resetFields: function() {
            //需要:model.sync
            this.$emit('update:model', Object.assign({}, this.defaultModel))
            this.clearValidate()
        },

        handleSubmit: function(e) {
            this.$emit('submit', {
                event: e,
                data: this.model
            })
        },
    },
}
</script>
